import {
  LitElement,
  html,
  css,
  Splide,
  animate,
  scroll,
} from '@hh/global.js'

class ProductFeatureCarousel extends LitElement {
  static properties = {}

  constructor() {
    super()
  }

  connectedCallback() {
    super.connectedCallback()
    this.initializeProductFeatureCarousel()
    this.initializeMediaSplide()
  }

  disconnectedCallback() {
    super.disconnectedCallback()
  }

  initializeProductFeatureCarousel() {
    scroll(
      animate('.js-list-container', {
        x: ['500px', 0],
      }),
      {
        target: this,
        offset: ['start end', 'start start'],
      }
    )

    const el = this.querySelector('.js-scroll-container')

    scroll(
      ({ y }) => {
        const totalScrollDistance = el.scrollWidth - el.clientWidth
        el.scrollLeft = totalScrollDistance * y.progress
      },
      {
        target: this,
        offset: ['start start', 'end end'],
      }
    )
  }

  initializeMediaSplide() {
    const carouselEl = this.querySelector('.js-carousel-container')
    if (!carouselEl) return

    this.splide = new Splide(carouselEl, {
      arrows: false,
      pagination: false,
      fixedWidth: '90%',
      gap: 16,
      mediaQuery: 'min',
      useScroll: true,
      breakpoints: {
        768: {
          destroy: true,
        },
      },
    })

    const progressBar = this.splide.root.querySelectorAll(
      '.js-splide-progress-bar'
    )

    this.splide.on('mounted move', () => {
      setTimeout(() => {
        const end = this.splide.Components.Controller.getEnd() + 1
        const rate = Math.min((this.splide.index + 1) / end, 1)

        progressBar.forEach((bar) => {
          bar.style.width = String(100 * rate) + '%'
        })
      }, 1)
    })

    this.splide.mount()
  }

  render() {
    return html`<slot></slot>`
  }
}

customElements.define('product-feature-carousel', ProductFeatureCarousel)
